import './bootstrap';
import '../scss/app.scss';
import '../scss/fonts.scss';

import { createApp, h, watch } from 'vue';
import { createInertiaApp, usePage } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { i18nVue } from 'laravel-vue-i18n';
import PrimeVue from 'primevue/config';
// Ziggy is installed through composer, not npm
import { ZiggyVue, route } from '../../vendor/tightenco/ziggy/dist/index.esm.js';
import { translation } from './translation';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(
        `./Pages/${name}.vue`,
        import.meta.glob('./Pages/**/*.vue'),
    ),
    setup({
        el, App, props, plugin,
    }) {
        const app = createApp({ render: () => h(App, props) });

        app.config.globalProperties.$disableNavigation = props.initialPage.props.disableNavigation
            ?? false;

        watch(
            () => usePage().props?.Ziggy?.defaults,
            (newDefaults) => {
                if (newDefaults) Ziggy.defaults = newDefaults;
            },
            { flush: 'sync', immediate: true },
        );

        app.use(plugin)
            .use(PrimeVue)
            .use(ZiggyVue)
            .mixin({ methods: { route } })
            .mixin(translation) // Vue2 simple translation
            .use(i18nVue, {
                // Vue3 advanced translations
                resolve: async (lang) => {
                    const langs = import.meta.glob('../lang/*.json');

                    // `{lang}.json` holds flat, sentence-style keys (e.g. "Cancel").
                    // `php_{lang}.json` is generated at build time from the nested
                    // PHP lang files (e.g. resources/lang/en/dashboard.php) and holds
                    // the namespaced "dashboard.email_log.title" style keys used by $t().
                    // Both need to be loaded and merged, or namespaced lookups fall
                    // back to printing the raw key.
                    const [flat, nested] = await Promise.all([
                        langs[`../lang/${lang}.json`]?.() ?? Promise.resolve({ default: {} }),
                        langs[`../lang/php_${lang}.json`]?.() ?? Promise.resolve({ default: {} }),
                    ]);

                    return { default: { ...flat.default, ...nested.default } };
                },
            })
            .mount(el);
    },
    progress: {
        color: '#121927',
        showSpinner: true,
    },
});
